/* eslint-disable import-extensions/file-extension-required */
import type { ApolloErrorInterop } from '@confluence/apollo-relay-interop-utils/entry-points/ApolloErrorInterop';
import { isUnauthorizedError } from '@confluence/error-boundary/entry-points/isUnauthorizedError';
import { markErrorAsHandled } from '@confluence/graphql/entry-points/markErrorAsHandled';

export const processError = (error?: ApolloErrorInterop): ApolloErrorInterop | undefined => {
	if (!error) {
		return undefined;
	}

	if (isUnauthorizedError(error)) {
		markErrorAsHandled(error);
		return undefined;
	}

	return error;
};
